// User types
export const FILTER_BY = {
    EMPLOYEE: "employee",
    CLIENT: "client",
};

// API endpoint suffixes
export const API_SUFFIX = {
    [FILTER_BY.EMPLOYEE]: "employees",
    [FILTER_BY.CLIENT]: "clients",
};

// Table constants
export const VISIBLE_ROWS = 5;